/**
 * @ngdoc Directive
 * @name vrm-password-input
 * @example
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmPasswordInput', vrmPasswordInput);

    /* @ngInject */
    function vrmPasswordInput() {

        var definition = {
            template: require('@/angular/modules/vrm-components/password-input/password-input.template.html'),
            scope: {
                model: '='
            },
            restrict: 'E',
            controller: ['$scope', controller]
        };

        return definition;

        /**
         * Controller
         * @param $scope
         */
        function controller($scope) {
            $scope.showPassword = false;

            $scope.togglePasswordVisibility = function() {
                $scope.showPassword = !$scope.showPassword;
            };
        };
    };
})();
